import React from 'react';
import { Link } from 'react-router-dom';

const AchievementCard = ({
  href,
  isExternal = false,
  icon,
  title,
  titleContent,
  titleClassName = "",
  organization,
  year,
  description,
  ctaText
}) => {
  const linkProps = isExternal
    ? { target: "_blank", rel: "noopener" }
    : {};

  const CardContent = () => (
    <>
      <div className="absolute -right-10 -top-10 w-40 h-40 bg-apple-gray-200 opacity-20 rounded-full group-hover:scale-125 transition-all duration-500"></div>
      <div className="absolute right-3 top-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-apple-gray-500 opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d={icon} />
        </svg>
      </div>
      <div className="flex-grow">
        <h3 className={`text-xl font-bold text-apple-gray-900 mb-3 relative z-10 ${titleClassName}`}>
          {titleContent || title}
        </h3>
        {(organization || year) && (
          <p className="text-apple-gray-700 font-medium mb-1">{[organization, year].filter(Boolean).join(', ')}</p>
        )}
        <p className="text-apple-gray-600 mb-4">{description}</p>
      </div>
      <div className="inline-flex items-center text-apple-gray-700 hover:text-apple-gray-900 font-semibold">
        {ctaText}
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </div>
    </>
  );

  const commonClassName = "bg-white p-6 rounded-xl shadow-md transform hover:scale-105 transition-all duration-300 border border-apple-gray-200 relative overflow-hidden group block";

  // Use Link for internal routes (starting with '/'), anchor tag for external links
  if (isExternal || (href && href.startsWith('http'))) {
    return (
      <a
        href={href}
        {...linkProps}
        className={commonClassName}
      >
        <CardContent />
      </a>
    );
  }

  return (
    <Link
      to={href}
      className={commonClassName}
    >
      <CardContent />
    </Link>
  );
};

export default AchievementCard;